import PropTypes from "prop-types";

import WhatsAppIcon from "./WhatsAppIcon";
import { buildWhatsAppUrl, WHATSAPP_MESSAGES } from "../../constants/whatsapp";
import { trackWhatsAppClick } from "../../services/trackingService";

const VARIANT_CLASSES = {
  solid:
    "bg-[#25D366] hover:bg-[#1fb855] text-white shadow-lg shadow-emerald-900/30 ring-2 ring-emerald-300/40",
  outline:
    "border border-[#25D366]/60 text-foreground hover:bg-[#25D366]/10 hover:border-[#25D366]",
};

const WhatsAppCta = ({
  source,
  message = WHATSAPP_MESSAGES.default,
  label = "Escribime por WhatsApp",
  variant = "solid",
  className = "",
}) => (
  <a
    href={buildWhatsAppUrl(message)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    onClick={() => trackWhatsAppClick(source)}
    className={`inline-flex items-center justify-center gap-2 rounded-full px-6 py-2 text-base font-bold transition-all duration-300 hover:scale-105 ${VARIANT_CLASSES[variant]} ${className}`}
  >
    <WhatsAppIcon />
    {label}
  </a>
);

WhatsAppCta.propTypes = {
  source: PropTypes.string.isRequired,
  message: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.oneOf(["solid", "outline"]),
  className: PropTypes.string,
};

export default WhatsAppCta;
